import cn from "classnames"
import richText from "utilities/richText"
import useHasIntersected from "utilities/useHasIntersected"

export default function TwoColumnSidebar({ blok }) {
  const { ref, isIntersecting } = useHasIntersected()

  return (
    <section className="two-column px-6 py-8">
      <div className="mx-auto max-w-screen-xl">
        <div className="flex flex-col gap-x-[70px] lg:flex-row">
          <div className="flex flex-col pb-12 lg:basis-2/3">
            <div className="column-main-content prose max-w-none">{richText(blok.main_content)}</div>
          </div>

          {blok.sidebar_content ? (
            <aside className="relative sm:mb-4 lg:basis-1/3">
              <div
                className={cn(
                  "sidebar-content prose max-w-none px-10 pb-10 pt-9 prose-headings:font-secondary prose-headings:font-medium prose-p:my-0",
                  {
                    "bg-stone-mid rounded-10 prose-headings:leading-9 prose-headings:text-evergreen-mid prose-p:my-2 prose-ul:my-2":
                      blok.sidebar_style === "sidebar",
                    "info-box rounded-10 bg-evergreen-mid text-white prose-headings:my-2 prose-headings:text-white prose-h3:mb-6 prose-h3:text-l3 prose-h3:leading-6 prose-h4:text-l2 prose-p:text-white":
                      blok.sidebar_style === "info-box",
                  },
                )}
              >
                {richText(blok.sidebar_content)}
              </div>
            </aside>
          ) : null}
        </div>
      </div>
    </section>
  )
}
